module.exports = __webpack_public_path__ + "img/smile_starfish.42996032.jpg";